import { z } from 'zod';
/**
 * Carte sociale (Sprint 4) — création de lots de cartes vierges, affectation
 * à un travailleur, personnalisation, remise/activation, suspension/
 * réactivation/remplacement. Le cycle de statuts lui-même est défini dans
 * `../constants/statuses.ts` (`CARTE_TRANSITIONS`) et appliqué côté API via
 * `apps/api/src/lib/carte-transitions.ts` — ces schémas ne valident que la
 * forme des requêtes, jamais la légalité d'une transition.
 */
export const createLotCarteSchema = z.object({
    numeroLot: z.string().min(1).max(40),
    typeLot: z.string().min(1).max(30),
    quantite: z.number().int().positive(),
    fournisseur: z.string().max(160).optional(),
});
export const createCarteSchema = z.object({
    travailleurUuid: z.string().uuid(),
    lotCarteId: z.number().int().positive(),
});
export const remettreCarteSchema = z.object({
    modeVerificationIdentite: z.string().min(1).max(30),
    preuveRemiseUrl: z.string().max(500).optional(),
});
export const suspendreCarteSchema = z.object({
    motif: z.string().min(1).max(500),
});
export const reactiverCarteSchema = z.object({
    motif: z.string().max(500).optional(),
});
export const remplacerCarteSchema = z.object({
    motif: z.string().min(1).max(500),
});
export const annulerCarteSchema = z.object({
    motif: z.string().min(1).max(500),
});
//# sourceMappingURL=cartes.js.map